const STATS = [
  { value: "1–2 Days", label: "Install time" },
  { value: "48 hrs", label: "Drive on it" },
  { value: "10-yr", label: "Warranty" },
  { value: "20+ yrs", label: "Lifespan" },
];

export function StatsStrip() {
  return (
    <section className="section-light border-y border-border bg-[#EEEBE5]">
      <div className="container-x grid grid-cols-2 sm:grid-cols-4 bg-[#EEEBE5]">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            className={[
              "py-8 md:py-10 px-4 text-center border-border",
              // mobile 2x2 borders
              i % 2 === 1 ? "border-l" : "",
              i >= 2 ? "border-t" : "",
              // desktop 1x4 borders (reset + left dividers)
              "sm:border-t-0",
              i === 0 ? "sm:border-l-0" : "sm:border-l",
            ].join(" ")}
          >
            <p className="font-display font-bold text-3xl md:text-4xl text-copper">{s.value}</p>
            <p className="mt-2 text-[10px] md:text-xs font-semibold uppercase tracking-[0.2em] text-[#121212]">
              {s.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
